import styled from 'styled-components';

import {
  ReactComponent as SpecialRemindersIcon,
} from '../../../../assets/icons/menuIcons/feedMenuIcons/special-reminders.svg';
import colors from '../../../../styles/colors';

const StyledContainer = styled.div`
  align-self: center;
  margin: 0 10px;
`;

// See CreateCoachTask: lime is unreadable on the light header buttons.
const StyledSpecialRemindersIcon = styled(SpecialRemindersIcon)`
  > path {
    fill: ${colors.base.beta};
  }
`;

export {
  StyledContainer,
  StyledSpecialRemindersIcon,
};
